import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "./ExchangeRate.css"
import { ReactComponent as ArrowBottom } from "../../assets/icons/main/main-arrow-bottom.svg"
import { ReactComponent as BTCLoader } from '../../assets/icons/main/bitkoinLoading.svg'
import {getPriceChangeClass} from "../../features/getPriceChangeClass";
import LTC from '../../assets/icons/main/LTC.png'
import TWT from '../../assets/icons/main/TWT.png'
import { useTranslation } from 'react-i18next';

const MarketHeader = ({ setMarketState, symbolMarket, coinTo }) => {
    const { t } = useTranslation(); // Подключение i18n

    const [marketInfo, setMarketInfo] = useState(null);
    const [isLoadedMarketInfo, setIsLoadedMarketInfo] = useState(false);

    const symbol = symbolMarket || (new URLSearchParams(window.location.search).get('symbol')) || 'BTCUSDT';

    useEffect(() => {
        let isMounted = true;
        let timer = null;

        const fetchMarketData = async () => {
            try {
                const { data } = await axios.get(`https://api-ru.fynex.cc/charts/api/24hr/${symbol}`);
                if (isMounted) {
                    setMarketInfo(data);
                    setIsLoadedMarketInfo(true);
                }
            } catch (error) {
                console.error('Ошибка при загрузке данных', error);
            }
            if (isMounted) {
                timer = setTimeout(fetchMarketData, 2500);
            }
        };

        fetchMarketData();

        return () => {
            isMounted = false;
            if (timer) clearTimeout(timer);
        };
    }, [symbol]);

    // ВАЖНО: порядок прямых детей .exchangeRate завязан на CSS (nth-child в мобильной версии):
    // 1 .symbol, 2 .big-price, 3 объём, 4 минимум, 5 максимум, 6 сумма
    return (
        isLoadedMarketInfo ? (
            <div className="exchangeRate">
                <div className="symbol" onClick={() => setMarketState(true)}>
                    <span className="coin">
                        {
                            coinTo &&
                                coinTo == "LTC" ? <img src={LTC} alt="" />  :
                                coinTo == "TWT" ? <img src={TWT} alt="" /> :
                                <img src={`https://api-ru.fynex.cc/api/static/icons/${coinTo.toLowerCase()}.png`} alt="" />
                        }
                    </span>
                    <span className="nm">{symbol.replace(coinTo, `${coinTo}/`)} <ArrowBottom /></span>
                </div>

                <div className="big-price">
                    <span className={`px fx-mono ${getPriceChangeClass(marketInfo.priceChangePercent)}`}>
                        {marketInfo.lastPrice < 1
                            ? Number(marketInfo.lastPrice).toFixed(11).replace(/\.?0+$/, "")
                            : Number(marketInfo.lastPrice).toFixed(2)
                        }
                    </span>
                    <span className={`chg fx-mono ${getPriceChangeClass(marketInfo.priceChangePercent)}`}>
                        {Number(marketInfo.priceChangePercent) >= 0 ? "+" : ""}{Number(marketInfo.priceChangePercent).toFixed(2)}%
                    </span>
                </div>

                <div className="stat">
                    <span>{t('exchangeRate.volume_24h')} ({coinTo})</span>
                    <b className="fx-mono">{(marketInfo.quoteVolume / 1e6).toFixed(2)}M</b>
                </div>
                <div className="stat">
                    <span>{t('exchangeRate.low_24h')}</span>
                    <b className="fx-mono">
                        {marketInfo.lowPrice < 1 ? Number(marketInfo.lowPrice).toFixed(11).replace(/\.?0+$/, "") : Number(marketInfo.lowPrice).toFixed(2)}
                    </b>
                </div>
                <div className="stat">
                    <span>{t('exchangeRate.high_24h')}</span>
                    <b className="fx-mono">
                        {marketInfo.highPrice < 1 ? Number(marketInfo.highPrice).toFixed(11).replace(/\.?0+$/, "") : Number(marketInfo.highPrice).toFixed(2)}
                    </b>
                </div>
                <div className="stat">
                    <span>{t('exchangeRate.sum_24h')}</span>
                    <b className="fx-mono">{(marketInfo.volume / 1e3).toFixed(2)}K</b>
                </div>
            </div>
        )
        :
        <div className='exchangeRate exchangeRateLoader'>
            <BTCLoader />
        </div>
    )

};

export default MarketHeader;
